import { z } from 'zod/v3';

export const UserFollowedDataSubjectMutationDtoSchema = z.object({
  dataSubjectId: z.number().optional(),
});
